import Moment from "moment";
import { parseApiDate } from "./";
import { ADMIN_TYPE } from "../utils/Constants";

const month = {
  0: "Jan",
  1: "Feb",
  2: "Mar",
  3: "Apr",
  4: "May",
  5: "Jun",
  6: "Jul",
  7: "Aug",
  8: "Sep",
  9: "Oct",
  10: "Nov",
  11: "Dec",
};
export const uploadStatusDateFormat = (timeStamp) => {
  const ts = new Date(timeStamp);
  const finalTime =
    ts.getDate() +
    " " +
    month[ts.getMonth()] +
    " " +
    ts.getFullYear().toString().slice(2, 4) +
    ", " +
    timeFromTimestamp(timeStamp);
  return finalTime;
  // Mon, 27 Apr 2020 06:11:49 GMT
};

const hours24to12 = (timeFormat) => {
  let timeString = timeFormat;
  const H = +timeString.substr(0, 2);
  const h = H % 12 || 12;
  const ampm = H < 12 || H === 24 ? " AM" : " PM";
  timeString = h + timeString.substr(2, 3) + ampm;
  return timeString;
};

const timeFromTimestamp = (timeStamp) => {
  const ts = new Date(timeStamp);
  const H = ts.getHours(ts);
  const h = H % 12 || 12;
  const ampm = H < 12 || H === 24 ? " AM" : " PM";
  const minutes =
    ts.getMinutes() < 10 ? `0${ts.getMinutes()}` : ts.getMinutes();
  const hour = h < 10 ? `0${h}` : h;
  const timeString = hour + ":" + minutes + ampm;
  return timeString;
};

export function getNotifictionDateFormat(inputDate) {
  let dateFormat = Moment(parseApiDate(inputDate));
  let outputDate =
    dateFormat && dateFormat.isValid() && dateFormat.format("DD MMM, YYYY");

  const today = Moment();
  let currentDate = today.format() && today.format("DD MMM, YYYY");
  if (currentDate === outputDate) {
    return "Today";
  }

  const yesterday = Moment().subtract(1, "day");
  let yesterdayDate = yesterday.format() && yesterday.format("DD MMM, YYYY");
  if (yesterdayDate === outputDate) {
    return "Yesterday";
  }

  return outputDate;
}

export function getFrequency(freq) {
  let Frequency = "";
  Frequency =
    freq === "D"
      ? "Daily"
      : freq === "W"
      ? "Weekly"
      : freq === "M"
      ? "Monthly"
      : null;
  return Frequency;
}

export function isSessionExpired(response) {
  if (
    (response.error != undefined && response.error.status_code === 401) ||
    response.status === "403" ||
    (response.status.internalMessage != null &&
      response.status.internalMessage.includes("403"))
  ) {
    return true;
  }
  return false;
}
export function deliveryDetailsDate(inputDate) {
  const dateFormat = Moment(parseApiDate(inputDate));
  const outputDate =
    dateFormat && dateFormat.isValid() && dateFormat.format("DD MMM, YYYY");
  return outputDate;
}


export function getLoggedInRole() {
  return localStorage.getItem("role");
}

export function getMerchantId() {
  let merchantId = null;
  let role = getLoggedInRole();
  if (role === ADMIN_TYPE.SUPERADMIN || role === ADMIN_TYPE.SALESADMIN) {
    merchantId = localStorage.getItem("globalMerchantId");
  }else if (role === ADMIN_TYPE.SCHOOLADMIN) {
    merchantId = localStorage.getItem("schoolAdminMerchantId");
  }
  return merchantId;
}

export function getPreprocessedData(data) {
    if (!Array.isArray(data)) {
      return [];
    }
    return data.map((item) => {
      let rakbankStatus = "No Info";
      let visaStatus = "No Info";
      if (Array.isArray(item.eppDetailsList)) {
        item.eppDetailsList.forEach((epp) => {
          if (epp.eppProvider && epp.status) {
            if (epp.eppProvider === "rakbank") {
              rakbankStatus = epp.status;
            } else if (epp.eppProvider === "visa") {
              visaStatus = epp.status;
            }
          }
        });
      }
  
      return {
        ...item,
        rakbankStatus,
        visaStatus,
      };
    });
  }